import { useCallback, useEffect, useState } from 'react'

import { useWallet } from '@solana/wallet-adapter-react'
import { useConnectModal } from './walletModal'

export const useWalletConnectGuard = (callback: () => void): (() => void) => {
  const wallet = useWallet()
  const setVisible = useConnectModal()

  const [isRequested, setIsRequested] = useState(false)

  const guardedAction = useCallback(() => {
    if (!wallet.connected) {
      setIsRequested(true)
      setVisible(true)
    } else {
      callback()
    }
  }, [callback, wallet.connected, setVisible])

  useEffect(() => {
    if (!wallet.connected) {
      return
    }

    if (isRequested) {
      setIsRequested(false)
      callback()
    }
  }, [callback, isRequested, wallet.connected])

  return guardedAction
}
